import { useCallback, useState } from 'react'

import { getKpiEligibleUsers } from '@/api/kpi'
import { EligibleUserModel } from '@/types'

interface UseKpiEligibleUsersReturn {
  eligibleUsers: EligibleUserModel[] | null
  loading: boolean
  error: Error | null
  fetchEligibleUsers: () => Promise<void>
}

const useKpiEligibleUsers = (): UseKpiEligibleUsersReturn => {
  const [eligibleUsers, setEligibleUsers] = useState<
    EligibleUserModel[] | null
  >(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchEligibleUsers = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const data = await getKpiEligibleUsers()

      const transformedUsers: EligibleUserModel[] = data.eligible_users.map(
        (user) => ({
          id: user.id,
          username: user.username,
          email: user.email,
          fullName: user.full_name,
        })
      )

      setEligibleUsers(transformedUsers)
    } catch (err) {
      const error =
        err instanceof Error ? err : new Error('Failed to fetch eligible users')
      setError(error)
      console.error('Error fetching eligible users:', error)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    eligibleUsers,
    loading,
    error,
    fetchEligibleUsers,
  }
}

export default useKpiEligibleUsers
